import Spark from 'app/assets/icons/SmartDocs/Spark.svg'
import { Box, Flex } from 'app/components/design-system-components'
import { ToolTip } from 'app/components/design-system-components/Tooltip'
import { Text } from 'app/components/design-system-components/typography'
import UpgradeCTA from 'app/components/design-system-components/UpgradeCTA'
import * as Display from 'app/components/display/display'
import UpgradeCTAFromSetting from 'app/components/display/smartdocs/upgradeCTAs/fromSetting'
import * as Form from 'app/components/forms/forms'
import theme from 'app/match/applicationReportPDF/assets/theme'
import GeneralBottomBtns from 'app/shared_components/general_bottom_btn/component'
import {
  getBankStatementRedactionTooltip,
  PREMIER_PLAN_LABEL,
} from 'app/sm/team_viewing_preference/AITools/bankStatementRedactionHelpers'
import { NEXT_GEN_LEASING_URL } from 'app/utils/text/helpers'

function AIToolsTab({
  isAccountLite = false,
  isActionDisabled = false,
  isUserAdmin = false,
  isBankStatementRedactionSettingEnabled = false,
  smartDocsForRenters,
  smartDocsForTeam,
  copilotEnabled,
  bankStatementRedactionEnabled,
  showBankStatementRedactionSetting = false,
  onClickSmartDocsForRenters,
  onClickSmartDocsForTeam,
  onClickCopilotEnabled,
  onClickBankStatementRedactionEnabled,
  onBackButtonClicked,
  onConfirmButtonClicked,
}) {
  const isBankStatementRedactionDisabled =
    !isUserAdmin || !isBankStatementRedactionSettingEnabled
  const shouldShowBankStatementRedactionPlanCTA =
    !isBankStatementRedactionSettingEnabled
  const bankStatementRedactionTooltipText = getBankStatementRedactionTooltip(
    isBankStatementRedactionSettingEnabled,
    isUserAdmin,
  )

  return (
    <>
      <Display.MainHeader
        hasSeperator={false}
        text={
          <Flex>
            <Box mr={3}>AI Tools (Beta)</Box>
            <img src={Spark} width={theme.width[7] + 'px'} alt="ai tools" />
          </Flex>
        }
        textClass="p0"
        componentClass="mb0"
      />

      <Display.DefaultBodyText>
        <p className="mb0 mt8">
          Enable Next Gen Leasing and benefit from faster application processing
          and improved accuracy.{' '}
          <a href={NEXT_GEN_LEASING_URL} target="_blank" rel="noreferrer">
            learn more
          </a>
        </p>
      </Display.DefaultBodyText>
      <Box mt={5}>
        {isAccountLite && <UpgradeCTAFromSetting />}

        <Flex alignItems="center">
          <Form.CheckBoxGeneral
            id="disableViewingTip"
            label="SmartDocs (Renter)"
            checked={smartDocsForRenters}
            onChange={onClickSmartDocsForRenters}
            componentClassName="mt10"
            eventProcessedByComponent
          />
          <ToolTip
            content="Enable SmartDoc processing for applicants. SmartDocs helps verify information supplied in Payslips and Rental Ledgers."
            toolTipID="smartDocsForRenters"
          />
        </Flex>

        <Flex alignItems="center">
          <Form.CheckBoxGeneral
            id="disableViewingTip"
            label="SmartDocs (Team)"
            checked={smartDocsForTeam}
            onChange={onClickSmartDocsForTeam}
            componentClassName="mt10"
            eventProcessedByComponent
            disabled={isActionDisabled}
            showDisabledGrey={isActionDisabled}
          />
          <ToolTip
            content="Enable SmartDoc processing for the team. SmartDocs helps verify information supplied in Payslips and Rental Ledgers."
            toolTipID="smartDocsForTeam"
          />
        </Flex>

        <Flex alignItems="center">
          <Form.CheckBoxGeneral
            id="disableViewingTip"
            label="Copilot"
            checked={copilotEnabled}
            onChange={onClickCopilotEnabled}
            componentClassName="mt10"
            eventProcessedByComponent
            disabled={isActionDisabled}
            showDisabledGrey={isActionDisabled}
          />
          <ToolTip
            content="Enable Copilot for application processing. Copilot provides insights and suggests actions."
            toolTipID="copilotEnabled"
          />
        </Flex>

        {showBankStatementRedactionSetting && (
          <>
            <Flex mb={5} mt={8} alignItems="center">
              <Text as="h4" fontSize={`${theme.fontSizes[8]}px`}>
                {PREMIER_PLAN_LABEL}
              </Text>
              {shouldShowBankStatementRedactionPlanCTA && (
                <Box ml={6}>
                  <UpgradeCTA
                    availableOn={PREMIER_PLAN_LABEL}
                    alignRight={false}
                    textContainerProps={{}}
                  />
                </Box>
              )}
            </Flex>
            <Flex alignItems="center">
              <Form.CheckBoxGeneral
                id="bankStatementRedactionEnabled"
                label="Bank Statement Redaction"
                checked={bankStatementRedactionEnabled}
                onChange={onClickBankStatementRedactionEnabled}
                componentClassName="mt10"
                eventProcessedByComponent
                disabled={isBankStatementRedactionDisabled}
                showDisabledGrey={isBankStatementRedactionDisabled}
              />
              <ToolTip
                content={bankStatementRedactionTooltipText}
                toolTipID="bankStatementRedactionEnabled"
              />
            </Flex>
          </>
        )}

        <Box className="pdf-hide">
          <GeneralBottomBtns
            onBackButtonClicked={onBackButtonClicked}
            onConfirmButtonClicked={onConfirmButtonClicked}
            confirmBtnText={'Update'}
          />
        </Box>
      </Box>
    </>
  )
}

export default AIToolsTab
